export default __webpack_public_path__ + "static/media/refund.419f3be6.svg";